module.exports = __webpack_public_path__ + "static/media/17a.8e33ca45.jpg";